(() => {
  'use strict';

  const codebrwnHosts = new Set([
    'codebrwn.com',
    'www.codebrwn.com',
    'codebrwn-2.myshopify.com',
  ]);

  if (!codebrwnHosts.has(window.location.hostname)) return;

  document.addEventListener(
    'click',
    (event) => {
      const element = event.target instanceof Element ? event.target.closest('#wp-cart-root a, #wp-cart-root button') : null;
      if (!element) return;

      const href = element.getAttribute('href') || '';
      const isLegacyWpCartCheckout = element.classList.contains('checkout-button') || href === '/cart' || href === '/cart/';
      if (!isLegacyWpCartCheckout) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const storeRoot = String(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      window.location.assign(`${storeRoot}checkout`);
    },
    true,
  );
})();
